import { DomainFilterType } from "src/app/model/enum/observations/domain-filter-type.enum";
import { Chip } from "../../common-components/model/chip.model";

export const DOMAIN_FILTER_CHIPS: Chip<DomainFilterType>[] = [
    { Label: 'by Component', Value: DomainFilterType.COMPONENT },
    { Label: 'by Domain', Value: DomainFilterType.DOMAIN },
    { Label: 'all Domains', Value: DomainFilterType.ALL },
    { Label: 'by Focus Areas', Value: DomainFilterType.FOCUS_AREAS },
];
